export default "__VITE_ASSET__ChE2ZiJj__"